import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { gsap } from 'gsap';
// import { FaCheckCircle } from 'react-icons/fa';

const InfoBar = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    gsap.fromTo(
      containerRef.current,
      { y: -50, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.8, ease: 'power3.out', delay: 0.5 }
    );
  }, []);

  return (
    <div
      ref={containerRef}
      className="bg-gradient-to-r from-primary via-primary-700 to-primary text-white py-2.5 mt-[100px] md:mt-[130px] relative overflow-hidden"
    >
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-1/4 w-32 h-32 bg-secondary rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-24 h-24 bg-secondary rounded-full blur-2xl"></div>
      </div>

      <div className="container mx-auto px-4 relative">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1, duration: 0.5 }}
          className="flex flex-wrap items-center justify-center gap-4 md:gap-8 text-sm"
        >
          {/* <div className="flex items-center gap-2">
            <FaShieldAlt className="text-secondary" />
            <span className="hidden md:inline">Licensed Australian Lender</span>
            <span className="md:hidden">Licensed Lender</span>
          </div>
          
          <div className="hidden sm:block w-px h-4 bg-white/30"></div>
          
         <div className="flex items-center gap-2">
            <FaCheckCircle className="text-secondary" />
            <span>ACL 519253</span>
          </div>
          
          <div className="hidden sm:block w-px h-4 bg-white/30"></div>
          */}
          
<div className="flex items-center justify-center gap-2 w-full mx-auto text-center">
  {/* <FaCheckCircle className="text-secondary flex-shrink-0 mt-1" /> */}
  <span>
    Aircash Finance ABN 88 692 896 138, Authorised Credit Representative Number 576018
    Facilitating Loans Provided by Strawberry Loans Pty Ltd ABN 74 621 474 655,
    Australian Credit Licence 519 253
  </span>
</div>

        </motion.div>
      </div>
    </div>
  );
};

export default InfoBar;
